import { inject, Injectable } from '@angular/core';
import { BaseFlowsStore } from '@kinet-open-network/client/flows/data-access';
import {
  loadItemPrices,
  LoadItemPricesMode,
  ProductPricesService,
} from '@kinet-open-network/client/product-prices/data-access';
import { ChangePriceFlowStatus } from '@kinet-open-network/shared/data-access/model-pbgas';
import { sumTotals } from '@kinet-open-network/shared/util';
import { FlowChangePrices } from './flow-change-prices.model';
import { FlowChangePricesService } from './flow-change-prices.service';

@Injectable()
export class FlowChangePricesStore extends BaseFlowsStore<
  FlowChangePrices,
  'id'
>(FlowChangePricesService) {
  override readonly service = inject(FlowChangePricesService);
  private readonly productPricesService = inject(ProductPricesService);

  override isTerminalState(status: string): boolean {
    return (
      status === ChangePriceFlowStatus.completed ||
      status === ChangePriceFlowStatus.rejected
    );
  }

  /** Reloads item prices for the offer's customer and `pricesValidFrom`; returns whether any price changed. */
  async loadPrices(mode: LoadItemPricesMode): Promise<boolean> {
    const model = this.model();
    if (!model?.items?.length) return false;

    const { items, changed } = await loadItemPrices(model.items, {
      service: this.productPricesService,
      customerId: model.customerId ?? null,
      date: model.pricesValidFrom
        ? new Date(model.pricesValidFrom)
        : new Date(),
      mode,
    });

    if (changed) {
      this.patchModel({
        items,
        ...sumTotals(items),
      } as Partial<FlowChangePrices>);
    }
    return changed;
  }
}
